import { llamar } from "./planillaMovimientos";

/* Las salidas de Buenos Aires de un día (ticket #432, Lautaro): los bitrenes
 * y los furgones comunes que salen hacia el sur, ya separados.
 *
 * La Previsión vive en FlotaBot y el hub no la puede leer (la tabla no tiene
 * policy para el hub), así que va por el puente SSO de siempre a
 * /api/satelital/salidas-bitren, que SÓLO lee. Lo que se escribe son sus
 * planillas, desde el hub, cuando él aprieta. */

const NO_PUEDO = "No podés pasar.";

export function traerSalidas(fecha) {
  const fd = new FormData();
  fd.append("fecha", fecha);
  return llamar("/api/satelital/salidas-bitren", fd, NO_PUEDO);
}

/* Lo mismo, leído del Excel de Gula que él suelta y no de la Previsión
 * (Lautaro, 20/10: «que te arrastre el excel y se complete en salidas
 * bitrenes y en salidas y cortes»). FlotaBot lo lee en memoria y lo
 * descarta: no se guarda ni se carga en la Previsión. `archivo` es la copia
 * retenida (`archivoRetenido`), no el puntero al disco. */
export function traerSalidasDelExcel(fecha, archivo) {
  const fd = new FormData();
  fd.append("fecha", fecha);
  fd.append("archivo", archivo);
  return llamar("/api/satelital/salidas-bitren", fd, NO_PUEDO);
}

/* Los bitrenes recién agregados a SALIDAS BITREN, a Enganches hacia Río
 * Grande (Lautaro, 21/10: «cuando se cargue en salidas de only bitrenes lo
 * que hay en cargas diarias, tambien se cargue en enganches»). Enganches lo
 * escribe sólo FlotaBot, con las llaves de «Subir» en Enganches: no duplica
 * nada equivalente y no pisa lo cargado. `bitrenes` es lo de
 * `bitrenesParaEnganches` (`shared/salidasEnganches`). */
export function cargarEnganchesDeSalidas(bitrenes) {
  const fd = new FormData();
  fd.append("bitrenes", JSON.stringify(bitrenes));
  return llamar("/api/satelital/salidas-bitren/enganches", fd, NO_PUEDO);
}
